import { Typography } from '@mui/material';
import { ApiWorthStatus } from 'multirpc-sdk';

import { ChainUptimeResult } from 'domains/status/utils/calculateChainUptime';
import { useStatusIcon } from 'domains/status/utils/useStatusIcon';
import { useAppSelector } from 'store/useAppSelector';
import { selectNameByChainPath } from 'modules/chains/store/selectors';

interface ChainStatusItemProps {
  chainStatus: ChainUptimeResult;
  className?: string;
}

export const ChainStatusItem = ({
  chainStatus,
  className,
}: ChainStatusItemProps) => {
  const { chainPath, overallUptimePercentage } = chainStatus;

  const chainName = useAppSelector(state =>
    selectNameByChainPath(state, chainPath),
  );

  // Convert percentage to status based on thresholds
  const getStatusFromPercentage = (percentage: number): ApiWorthStatus => {
    if (percentage >= 99.9) return 'operational';
    if (percentage >= 80) return 'degraded_performance';
    if (percentage >= 50) return 'partial_outage';

    return 'major_outage';
  };

  const status = getStatusFromPercentage(overallUptimePercentage);
  const statusIcon = useStatusIcon({ status });
  const uptimeText = `${parseFloat(overallUptimePercentage.toFixed(2))}%`;

  return (
    <Typography component="p" variant="body4" className={className}>
      {statusIcon} {chainName}: ({uptimeText})
    </Typography>
  );
};
